import './Header.css'
import Search from './search/Search'
import { useState } from 'react'
import { Link } from 'react-router-dom'

function Header(props) {
    const [showSearch, setShowSearch] = useState(false)
    const [hoverFilter, setHoverFilter] = useState(false)
    const [hoverSearch, setHoverSearch] = useState(false)

    const showSearchBox = () => {
        setShowSearch(true)
        setHoverSearch(false)
    }

    const showFilter = () => {
        let modal = document.getElementById("myModal");
        modal.style.display = "block";
        setHoverFilter(false)
    }

    return (
        <>
            {!showSearch ?
                <div className="header">
                <div>
                    <img 
                        src={hoverSearch ? "/img/search-hover.png" : "/img/search.png"}
                        onMouseOver={() => setHoverSearch(true)}
                        onMouseOut={() => setHoverSearch(false)} 
                        alt="Öppna sökruta" 
                        onClick={showSearchBox} 
                    />
                </div>
                <div>
                    <Link to="/">
                        <img 
                            src="img/favicon.png" 
                            alt="Kolla Frukten Logo" 
                        />
                    </Link>
                </div>
                <div>
                    <img 
                        src={hoverFilter ? "/img/settings-hover.png" : "/img/settings.png"}
                        onMouseOver={() => setHoverFilter(true)}
                        onMouseOut={() => setHoverFilter(false)}
                        alt="Filter" 
                        onClick={showFilter}
                    />
                </div>
                </div>
            : 
                null
            }
            {showSearch ? 
                <Search 
                    setShowSearch={setShowSearch} 
                    setSearchValue={props.setSearchValue} 
                /> 
            : 
                null
            }
        </>
    )
}

export default Header